import { handleActions } from 'redux-actions';

import { GOOGLE_MAPS_SCRIPT } from '../../types';

const initialState = {
  isFetching: true
};

const googleMapsReducer = {
  [GOOGLE_MAPS_SCRIPT]: (state = initialState, { payload }) => ({
    ...state,
    isFetching: payload
  })
};

const googleMaps = handleActions(
  {
    ...googleMapsReducer
  },
  initialState
);

export default googleMaps;
